import { cdaApiRoutes } from 'constants/routes/cdaApiRoutes'
import axiosClients from './axiosClient'
import {
	IGoCardlessBankItem,
	IGoCardlessCompleteRequest,
	IGoCardlessCompleteResponse,
	IGoCardlessCreateLinkRequest,
	IGoCardlessCreateLinkResponse,
} from 'interfaces/i-gocardless'

const cdaClient = axiosClients.getCdaClient()

const goCardlessServices = {
	async getGoCardlessInstitutions(country: string) {
		const data = await cdaClient.get<IGoCardlessBankItem[]>(
			cdaApiRoutes.getGoCardlessInstitutions(country),
		)

		if (data.status === 200) {
			if (data.data) return data.data
			else throw new Error('Failed to fetch goCardless institutions')
		}

		throw new Error('Failed to fetch goCardless institutions')
	},

	async createGoCardlessLink(
		createLinkRequest: IGoCardlessCreateLinkRequest,
	) {
		const data = await cdaClient.post<IGoCardlessCreateLinkResponse>(
			cdaApiRoutes.createGoCardlessLink,
			createLinkRequest,
		)
		if (data.status === 200) return data.data
		throw new Error('Failed to create goCardless link')
	},

	async complete(completeRequest: IGoCardlessCompleteRequest) {
		const data = await cdaClient.post<IGoCardlessCompleteResponse>(
			cdaApiRoutes.completeGoCardless,
			completeRequest,
		)
		if (data.status === 200) return data.data
		throw new Error('Failed to complete goCardless')
	},
}

export default goCardlessServices
